module.exports = __webpack_public_path__ + "static/media/img8.560558a0.jpg";